import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import MicroModal from "micromodal";
import moment from "moment";
import axios from "axios";
import { sub, format } from "date-fns";
import MicRecorder from "mic-recorder-to-mp3";
import ReactHtmlParser from "react-html-parser";

import {
  addChat,
  addChatSimult,
  typingadd,
  clearConferenceExt,
  CallConsultaInterna,
  addMonitoring,
  addMonitoringSimult,
  EditTypeMonitorings,
  EditTypeMonitoringm,
  SendNextMonitoring,
  CloseMonitoring,
  GetDetailsContacts,
  AddNumberContact,
  GetPhoneMidia,
  senfFileQuickAswMonitoring,
  addMessage,
  InsertUploadMonitoring,
  RespostasRapidasida,
  DetailsAnotationsida,
  GetInteractionsModal,
  InsertUpload,
  editMsg,
  deleteEmailMsg,
  InteracoesContactNumber,
  SearchingHistoryData,
  DetailsMarkstarida,
  DetailsFileShared,
  dbfileSize,
  InsertAnotations,
} from "../../actions";
import {
  InitialMonitoring,
  SharedScreen,
  InviteMessagesMonitoring,
  changeDisplayByeChat,
} from "../../actions/websocket";
import { Tooltippy, Popover as Tippy } from "../../actions/Tippy";
import unicodeToChar from "../../actions/formatUnicode";

import Typography from "../Typography";
import UserPhoto from "../UserPhoto/userphoto";
import InteractionChat from "../InteractionChat/InteractionChat";
import TransferClientModal from "../../containers/TransferClientModal";
import NewAnotationModal from "./NewModals/AnotationModal/AnotationModal";
import TimeCounter from "../../containers/TimeCounter";
import MailContainer from "../mail-section/MailContainer";
import QuickAnswer from "../../containers/QuickAnswer";
import TimeCounterMinute from "../../containers/TimeCounterMinute";
import AudioVisualizer from "../AudioVisualizer/AudioVisualizer";
import AudioWaveform from "../AudioVisualizer/AudioWaveform";
import AddAnotationModal from "./NewModals/AddAnotationModal/AddAnotationModal";
import MessageList from "../ChatRenderer/ChatRenderer";

import { connection_platform } from "../../services/api";
import "./modals.css";

import { ReactComponent as WhatsappIcon } from "../../build/images/icons-channels/whatsapp-large.svg";
import { ReactComponent as FacebookIcon } from "../../build/images/icons-channels/facebook.svg";
import { ReactComponent as VozIcon } from "../../build/images/icons-channels/voz-large.svg";
import { ReactComponent as EmailIcon } from "../../build/images/icons-channels/email.svg";
import { ReactComponent as WebchatIcon } from "../../build/images/icons-channels/webchat-large.svg";
import { ReactComponent as TelegramIcon } from "../../build/images/icons-channels/telegram-large.svg";
import { ReactComponent as GOOGLEGBM } from "../../build/images/icons-channels/googlegbm-large.svg";
import { ReactComponent as InstaIcon } from "../../build/images/icons-channels/instagram-large.svg";
import { ReactComponent as SMSICON } from "../../build/images/sms-new.svg";
import { ReactComponent as TWITTERICON } from "../../build/images/twitter-new.svg";
import { ReactComponent as CallIcon } from "../../build/images/viewactioncall.svg";
import { ReactComponent as SussurroIcon } from "../../build/images/viewactionprofile.svg";
import { ReactComponent as ListeningIcon } from "../../build/images/teams/monitorias/sigilosa.svg";
import { ReactComponent as PointMessageIcon } from "../../build/images/viewactionmessagepoint.svg";
import { ReactComponent as TEAMS } from "../../build/images/channelsNew/teamsBig.svg";
import { ReactComponent as ActionIcon } from "../../build/images/more.svg";
import { ReactComponent as Transferir } from "../../build/images/popover-queue/redo.svg";
import { ReactComponent as Anotacoes } from "../../build/images/popover-queue/edit-2.svg";
import { ReactComponent as Search } from "../../build/images/teams/search-normal.svg";
import { ReactComponent as ENCERRARATENDIMENTO } from "../../build/images/icons/byeatendant-client-icon.svg";
import { ReactComponent as MensagemPredefinidas } from "../../build/images/message-text.svg";
import { ReactComponent as AnexarItem } from "../../build/images/paperclip.svg";
import { ReactComponent as SEND } from "../../build/images/send-2.svg";
import { ReactComponent as IconAudio } from "../../build/images/microphone-2.svg";
import { ReactComponent as ArrowDown } from "../../build/images/arrow_down.svg";
import { ReactComponent as InfoCircle } from "../../build/images/info-circle.svg";
import { ReactComponent as LoginSvg } from "../../build/images/login.svg";
import { ReactComponent as ArrowLeft } from "../../build/images/icon_arrow_left.svg";
import { saudacaoPorHorario } from "../../utils/saudacaoPorHorario";

let gethostname = window.location.hostname;
let pathname = "";

let iplocal = connection_platform.ip_intern;
let port = connection_platform.port_backend_intern;
port = localStorage.getItem("port");

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

let ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

const { meses } = require("../../services/data");
const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const MonitoringDashboard = ({
  isOpen,
  openClick,
  onClose,
  attendant = { label: "Atendente Teste" },
  infoJson,
}) => {
  const InfoUsers = useSelector((state) => state.informationusers);
  const MonitoringSimult = useSelector((state) => state.monitoringsimult);
  const Monitoring = useSelector((state) => state.monitoring);
  const ChatSimult = useSelector((state) => state.chatsimult);
  const ClientUserMonitors = useSelector((state) => state.clientusermonitors);
  const Messages = useSelector((state) => state.messages);
  const RespostasRapidas = useSelector((state) => state.respostas);
  const NpsDetails = useSelector((state) => state.npsdetails);
  const MailMessage = useSelector((state) => state.messagemail);
  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);
  const History = useSelector((state) => state.history);
  const DetailsAnotations = useSelector((state) => state.detailsanotations);
  const DetailsMarkstar = useSelector((state) => state.detailsmarkstars);
  const DetailsFileSharedIn = useSelector((state) => state.detailsfileshared);
  const CriticidadesAnotacoes = useSelector((state) => state.criticalitys);
  const dispatch = useDispatch();

  const [selectedChat, setSelectedChat] = useState(null);
  const [arrayChats, setArrayChats] = useState([]);
  const [typeMonitoring, setTypeMonitoring] = useState(1);
  const [monitorMessage, setMonitorMessage] = useState([]);
  const [fileasw, setFileasw] = useState([]);
  const [buttonQuickAnswer, setButtonQuickAnswer] = useState(false);
  const [respostasinicial, setRespostasinicial] = useState([]);
  const [respostas, setRespostas] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const [loaded, setLoaded] = useState(null);
  const [transferInfo, setTransferInfo] = useState(null);
  const [record, setRecord] = useState(false);
  const [timerecording, setTimerecording] = useState(-1);
  const [isRecording, setIsRecording] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [blobURL, setBlobURL] = useState("");
  const [messageQuickAnswer, setMessageQuickAnswer] = useState("");
  const [variableQuickAnwser, setVariableQuickAnwser] = useState([]);
  const [paramsHSM, setParamsHSM] = useState([]);
  const [isHSM, setIsHSM] = useState(false);
  const [editableQuickAnswer, setEditableQuickAnswer] = useState(false);
  const [checkparam, setCheckparam] = useState(false);
  const [checkparam2, setCheckparam2] = useState(false);
  const [searchQuickMsg, setSearchQuickMsg] = useState("");
  const [openDetails, setOpenDetails] = useState(false);
  const [detailsOptions, setDetailsOptions] = useState({
    interactions: false,
    notes: false,
    favMsg: false,
    shareArchives: false,
  });
  const [historyInfo, setHistoryInfo] = useState([]);
  const [noteComment, setNoteComment] = useState("");
  const [openSearch, setOpenSearch] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchWord, setSearchWord] = useState({ atual: 0, total: 0 });
  const [hasVoice, setHasVoice] = useState(false);
  const [saveAttendant, setSaveAttendant] = useState("");
  const [scrollIndex, setScrollIndex] = useState(0);

  port = localStorage.getItem("port");
  const carouselRef = useRef(null);
  let closeRef = useRef();
  let auxdia = "";
  let dia = "";
  // let searchText = "";
  let valorInput = "";
  // let arrowterm = 0;

  // Array com informações de cada chat (nome, id, e algum identificador de rede social)
  const chats = [
    { id: 1, name: "Bruna Cardoso", time: "11:52:23", socialId: "whatsapp" },
    { id: 2, name: "Agatha Mayra", time: "11:52:23", socialId: "facebook" },
    {
      id: 3,
      name: "Piotr Zalkowitch",
      time: "11:52:23",
      socialId: "instagram",
    },
    { id: 4, name: "Bruna Cardoso", time: "11:52:23", socialId: "twitter" },
  ];

  function makeid(length) {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  const getMediaIcon = (mediaId) => {
    switch (parseInt(mediaId)) {
      case 1:
        return <VozIcon />;
      case 2:
        return <WebchatIcon />;
      case 3:
        return <EmailIcon />;
      case 4:
        return <FacebookIcon />;
      case 5:
        return <WhatsappIcon />;
      case 6:
        return <InstaIcon />;
      case 8:
        return <TelegramIcon />;
      case 9:
        return <TWITTERICON />;
      case 11:
        return <GOOGLEGBM />;
      case 12:
        return <SMSICON />;
      case 15:
        return <TEAMS />;
      default:
        break;
    }
  };

  const closeModal = (modal) => {
    closeMonitoringIn(MonitoringSimult[0], Monitoring, MonitoringSimult);
    // arrowterm = 0;
    setTypeMonitoring(1);
    setHasVoice(false);
    setArrayChats([]);
    setSelectedChat(null);
    setMonitorMessage([]);
    setSaveAttendant("");
    setOpenDetails(false);
    setDetailsOptions({
      interactions: false,
      notes: false,
      favMsg: false,
      shareArchives: false,
    });
    setOpenSearch(false);
    // MicroModal.close(modal);
    onClose();
  };

  function createJSON(item) {
    if (item) {
      var mensagem_tratada = item.replace(/¿/gi, "\n");
      mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
      let valor = 1;
      try {
        mensagem_tratada =
          '{"' +
          valor +
          '": [{"mensagem_tratada":"' +
          mensagem_tratada +
          '"}]}';
        var obj = JSON.parse(mensagem_tratada);
        mensagem_tratada = obj[1][0].mensagem_tratada;
      } catch (e) {
        mensagem_tratada = item;
      }
      return mensagem_tratada;
    }
  }

  function isJson(item) {
    item = typeof item != "string" ? JSON.stringify(item) : item;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === "object" && item != null) {
      return true;
    }

    return false;
  }

  function tratarUnderline(valor) {
    valor = valor.split(" ");
    const expresionRegular = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let valorFim = [];
    for (let variavel of valor) {
      if (!expresionRegular.test(variavel)) {
        variavel = variavel
          .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
          .replaceAll("\n", "</br>")
          .replaceAll('"}', "")
          .replaceAll("\\n", "</br>")
          .replaceAll("\n", "</br>")
          .replaceAll("\\r", "")
          .replaceAll("\r", "")
          .replace(/_(.*?)_/g, "<em>$1</em>");
      }
      valorFim.push(unicodeToChar(variavel));
    }
    return valorFim.join(" ");
  }

  const closeMonitoringIn = (simult, monitoring, monitoringsimult) => {
    // e.preventDefault();
    if (monitoringsimult.length > 0) {
      // if (monitoringsimult.length > 1) {
      //   let j = 0;
      //   if (simult.userout === monitoringsimult[0].userout) {
      //     j = 1;
      //   }
      //   dispatch(SendNextMonitoring(monitoringsimult[j]));
      // }
      dispatch(CloseMonitoring(simult, monitoringsimult));
    }
  };

  const InitialMonitoringAction = (
    userin,
    userout,
    name,
    monitoringsimult,
    line,
    ramal
  ) => {
    let erro = 0;
    let auxline;
    if (monitoringsimult.length != 0) {
      monitoringsimult.map((monitoring) => {
        if (parseInt(monitoring.userout) === parseInt(userout)) {
          erro = 1;
          auxline = monitoring.line;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        if (parseInt(auxline) !== parseInt(line)) {
          editTypeMonitoring(userout, line, userin, ramal);
        }
      } else {
        reduxMonitoringInitial(userin, userout, name, line, ramal);
      }
    } else {
      reduxMonitoringInitial(userin, userout, name, line, ramal);
    }
  };

  const reduxMonitoringInitial = (userin, userout, name, line, ramal) => {
    dispatch(addMonitoring(userout, name, line, ramal));
    dispatch(addMonitoringSimult(userout, name, line, ramal));
    if (line != "4") {
      const socket = InitialMonitoring(userin, userout, line, ramal);
    } else {
      const socket = SharedScreen(ramal);
    }
  };

  const editTypeMonitoring = (userout, line, userin, ramal) => {
    dispatch(EditTypeMonitorings(userout, line));
    dispatch(EditTypeMonitoringm(userout, line));
    if (line != "4") {
      const socket = InitialMonitoring(userin, userout, line, ramal);
    } else {
      const socket = SharedScreen(ramal);
    }
  };

  const InitialCall = (chatsimult, user) => {
    let erro = 0;

    if (chatsimult.length != 0) {
      chatsimult.map((chat) => {
        if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === false
        ) {
          erro = 1;
        } else if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === true
        ) {
          erro = 2;
        } else if (erro != 1 || erro != 2) {
          erro = 0;
        }
      });
      if (erro === 1) {
        reduxCallInitial(
          parseInt(user.iduser),
          user.label,
          user.ramal,
          user,
          true
        );
      } else if (erro === 2) {
        console.log("JA POSSUI CHAT ATIVO COM VOZ");
      } else {
        reduxCallInitial(
          parseInt(user.iduser),
          user.label,
          user.ramal,
          user,
          false
        );
      }
    } else {
      reduxCallInitial(
        parseInt(user.iduser),
        user.label,
        user.ramal,
        user,
        false
      );
    }
  };

  const reduxCallInitial = (iduser, label, ramal, user, isConference) => {
    if (isConference) {
      dispatch(clearConferenceExt());
      dispatch(CallConsultaInterna(ramal, iduser, user));
      // dispatch(AlterScreen('Atendentes'))
      // dispatch(ShowInfoDisplay('Atendentes'))
    } else {
      reduxChatInitial(iduser, label, true, false, ramal);
      dispatch(CallConsultaInterna(ramal, iduser, user));
    }
    document.getElementById("simulation_click").click();
  };

  const reduxChatInitial = (iduser, displayname, active, opencall, ramal) => {
    let datatime = moment().format("YYYY/MM/DD HH:mm:ss");
    dispatch(
      addChatSimult(iduser, displayname, active, opencall, ramal, datatime)
    );
    dispatch(addChat(iduser, displayname, active, opencall, ramal, datatime));
    dispatch(typingadd(iduser, displayname));
    document.getElementById("simulation_click").click();
    // dispatch(AlterScreen('Atendentes'))
    // dispatch(ShowInfoDisplay('Atendentes'))
  };

  const addNumberContact = (post, number) => {
    dispatch(AddNumberContact(post, number));
    dispatch(GetPhoneMidia([]));
  };

  const handleAddContact = (contact, typeModal, bind) => {
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontacts?number=${contact.telefone}&nome=&empresa=&contato=&codext=&email=`
      )
      .then((response) => {
        if (response.data.length > 0) {
          if (typeModal === "link") {
            MicroModal.show("modal__linkAdd-contact");
            dispatch(GetDetailsContacts(false, response.data[0]));
          } else {
            dispatch(GetDetailsContacts(true, response.data[0], ""));
          }
        } else {
          if (typeModal === "link") {
            MicroModal.show("modal__linkAdd-contact");
            dispatch(GetDetailsContacts(false, contact));
          } else {
            dispatch(GetDetailsContacts(true, "", contact));
            addNumberContact("", contact.telefone);
          }
        }
        // this.setState({ cursorState: false });
      });
  };

  const exibInfosContact = (contact) => {
    let infos = [];

    if (contact.menubot) {
      infos = contact.menubot.split("~¿");

      return (
        <ul className="tippy-infos">
          {infos.map((info) => (
            <li>{info}</li>
          ))}
        </ul>
      );
    } else {
      return (
        <ul className="tippy-infos">
          <li>{contact.cliente}</li>
          <li>{contact.recuperationtime}</li>
        </ul>
      );
    }
  };

  const exibActionsContact = (
    number,
    cliente,
    cdrid,
    infouser,
    iduser,
    serverid,
    client,
    idmidia
  ) => {
    return (
      <ul className="context-menu__list">
        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            changeDisplayTransfer(event, cdrid, serverid, iduser, number)
          }
        >
          <Transferir />
          <div className="contact-info__name">Transferir</div>
        </li>

        <li
          onClick={(event) => ViewAnotations(event, number, cliente, cdrid)}
          className="contact-info contact-info--with-action"
        >
          <Anotacoes />
          <div className="contact-info__name">Anotações</div>
        </li>

        <li
          onClick={() => setOpenSearch(true)}
          className="contact-info contact-info--with-action"
        >
          <Search width="16" height="16" />
          <div className="contact-info__name">Pesquisa</div>
        </li>

        <li
          className="contact-info contact-info--with-action"
          onClick={(event) => {
            // this.props.changeDisplayByeChat(cdrid, serverid, iduser, infouser)
            changeDisplayByeChat(cdrid, serverid, iduser, infouser);
            setSelectedChat(null);
            setMonitorMessage([]);
            if (parseInt(client.idmidia) === 3) {
              dispatch(deleteEmailMsg(cdrid));
            }
          }}
        >
          <ENCERRARATENDIMENTO />
          <div className="contact-info__name">Encerrar atendimento</div>
        </li>
      </ul>
    );
  };

  const changeDisplayTransfer = (e, cdrid, serverid, usermon, number) => {
    console.log("INGENIUMCHECKTTANSFER_TELCLIENTE: ", number);
    MicroModal.show("modal__transferir__chamada");
    localStorage.setItem("idcdr", cdrid);
    localStorage.setItem("serverid", serverid);
    localStorage.setItem("usermon", usermon);
    localStorage.setItem("telcliente", number);
  };

  const ViewAnotations = (e, telefone, cliente, cdrid) => {
    // MicroModal.show("modal__anotacoes-details-new");
    MicroModal.show("modal__anotacoes-adicionar");
    buttonSearchAnotation(e, telefone);
    // this.setState({
    //   numbercliente: telefone,
    //   namecliente: cliente,
    //   idcdr: cdrid,
    // });
    dispatch(GetInteractionsModal(cliente, telefone, cdrid));
  };

  const buttonSearchAnotation = (e, telefone) => {
    e.preventDefault();

    let erro = 0;
    const datainit = format(
      sub(new Date(), {
        months: 1,
      }),
      "yyyy-MM-dd"
    );
    const datafim = format(new Date(), "yyyy-MM-dd");
    const idcriticidade = "";

    let comparation = moment(datainit).isBefore(datafim);

    if (datainit == "") erro = 1;

    if (datafim == "") erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      // this.props.DetailsAnotationsida(
      //   datainit,
      //   datafim,
      //   idcriticidade,
      //   telefone
      // );
      dispatch(
        DetailsAnotationsida(datainit, datafim, idcriticidade, telefone)
      );
    }
  };

  const handleKeyPress = (event) => {
    var el = document.getElementById("chat-message");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  const handleKeyDown = (event) => {
    var el = document.getElementById("chat-message");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  const sendImageAsw = (
    makeid,
    message,
    author,
    infousers,
    contactid,
    typemsg,
    line
  ) => {
    let time = moment().format("HH:mm");
    let dia = moment().format("DD");
    let mes = moment().format("MM");
    let ano = moment().format("YYYY");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    if (message != "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          contactid.idatendimento,
          typemsg,
          "entregue",
          false,
          dia,
          infousers.username,
          "",
          "",
          line,
          "",
          "",
          "",
          ano,
          moment().format("DD/MM/YYYY HH:mm")
        )
      );
    }
  };

  const InviteMessage = (
    makeid,
    message,
    author,
    infousers,
    contactid,
    typemsg,
    msgsocket,
    line
  ) => {
    let time = moment().format("HH:mm");
    let dia = moment().format("DD");
    let mes = moment().format("MM");
    let ano = moment().format("YYYY");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    if (message != "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          contactid.idatendimento,
          typemsg,
          "entregue",
          false,
          dia,
          infousers.username,
          "",
          "",
          line,
          "",
          "",
          "",
          ano,
          moment().format("DD/MM/YYYY HH:mm")
        ),
        InviteMessagesMonitoring(
          infousers,
          contactid,
          msgsocket,
          author,
          makeid,
          line
        )
      );
    }
  };

  const scrollDown = () => {
    const scrollableDiv = document.querySelector(".chat-window");

    // scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
    requestAnimationFrame(() => {
      scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
    });
  };

  const handleOnChange = (event, InfoUsers, ContactId, line) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      let teste = document.getElementsByClassName("chat-message");
      let msgweb = document.getElementById("chat-message").innerText;
      let msgsocket = document.getElementById("chat-message").innerText;
      let infosendfile = fileasw;

      if (fileasw != null && infosendfile[2] != 1 && infosendfile.length > 0) {
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        let str = msgweb.replace(/\s/g, "");
        if (str != "") {
          if (infosendfile[0] != "") {
            senfFileQuickAswMonitoring(
              InfoUsers,
              ContactId,
              infosendfile[0],
              msgweb,
              makeid(32),
              line
            );
          }
          sendImageAsw(
            makeid(32),
            " ~¿" + msgweb + "~¿" + infosendfile[0],
            "Me",
            InfoUsers,
            ContactId,
            1,
            line
          );
        }

        document.getElementById("chat-message").innerHTML = "";
        scrollDown();
      } else {
        let str = msgweb.replace(/\s/g, "");
        if (str != "") {
          msgweb = msgweb.trim();
          msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          msgsocket = msgsocket.trim();
          msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
          InviteMessage(
            makeid(32),
            msgweb,
            "Me",
            InfoUsers,
            ContactId,
            "0",
            msgsocket,
            line
          );
          document.getElementById("chat-message").innerHTML = "";
          scrollDown();
          // this.props.sendtyping(0, InfoUsers, ContactId);NÃO MANDAR TYPPINY POR ENQUANTO
        }
      }
    }
  };

  const ButtonSendMessage = (
    event,
    author,
    InfoUsers,
    ContactId,
    typemsg,
    line
  ) => {
    event.preventDefault();
    document.getElementById("chat-message").disabled = false;
    let msgweb = document.getElementById("chat-message").innerText;
    let msgsocket = document.getElementById("chat-message").innerText;

    let infosendfile = fileasw;

    if (fileasw != null && infosendfile[2] != 1 && infosendfile.length > 0) {
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        if (infosendfile[0] != "") {
          senfFileQuickAswMonitoring(
            InfoUsers,
            ContactId,
            infosendfile[0],
            msgweb,
            makeid(32),
            line
          );
        }
        sendImageAsw(
          makeid(32),
          " ~¿" + msgweb + "~¿" + infosendfile[0],
          "Me",
          InfoUsers,
          ContactId,
          1,
          line
        );
      }
    } else {
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        InviteMessage(
          makeid(32),
          msgweb,
          "Me",
          InfoUsers,
          ContactId,
          typemsg,
          msgsocket,
          line
        );
      }
    }
    scrollDown();
    document.getElementById("chat-message").innerHTML = "";
  };

  const DisplayQuickAnswer = (e) => {
    e.preventDefault();
    setButtonQuickAnswer(!buttonQuickAnswer);
    // this.setState({ buttonQuickAnswer: !this.state.buttonQuickAnswer });
    // const { RespostasRapidas } = this.props;
    // this.state.respostasinicial = RespostasRapidas.respostas;

    setRespostasinicial(RespostasRapidas.respostas);
    // this.state.respostas = this.state.respostasinicial;
    setRespostas(RespostasRapidas.respostas);
  };

  const InsertQuickAnswer = (
    event,
    texto,
    editable,
    mimetypeid,
    filepath,
    InfoUsers,
    ContactId,
    resp
  ) => {
    event.preventDefault();

    let textReceived = texto;
    let checksocialname = texto.indexOf(`{SYS.SOCIALNAME}`);
    let checkNumProtocol = texto.indexOf(`{SYS.PROTOCOLO}`);
    let checkvalueSName = false;
    // this.setState({ isHSM: false });
    // this.setState({ editableQuickAnswer: false });
    setIsHSM(false);
    setEditableQuickAnswer(false);

    let checkvalueSProtocol = false;

    if (checksocialname > 0) {
      checkvalueSName = true;
    } else {
      checkvalueSName = false;
    }

    if (checkNumProtocol > 0) {
      checkvalueSProtocol = true;
    } else {
      checkvalueSProtocol = false;
    }

    let checknomeagente = texto.indexOf(`{SYS.NOMEAGENTE}`);
    let checkvalueNAgent = false;
    if (checknomeagente > 0) {
      checkvalueNAgent = true;
    } else {
      checkvalueNAgent = false;
    }

    texto = texto.replace(
      "${SYS.SOCIALNAME}",
      createJSON(ContactId.cliente.trim())
    );
    texto = texto.replace(
      "${SYS.NOMEAGENTE}",
      createJSON(InfoUsers.displayname.trim())
    );

    const saudacao = saudacaoPorHorario();
    texto = texto.replace("${SYS.GREETING}", createJSON(saudacao.trim()));
    texto = texto.replace("${SYS.SAUDACAO}", createJSON(saudacao.trim()));

    if (NpsDetails.length !== 0) {
      const filterNpsClientDetails = NpsDetails.filter(
        (nps) => nps.numero_cliente === ContactId.telefone
      );

      if (filterNpsClientDetails.length !== 0) {
        texto = texto.replace(
          "${CAMP.NOMECLIENTE}",
          createJSON(filterNpsClientDetails[0].nome_cliente)
        );
      }
    }

    if (checkvalueSProtocol && ContactId.protocolo) {
      texto = texto.replace(
        "${SYS.PROTOCOLO}",
        createJSON(ContactId.protocolo.trim())
      );
    }

    try {
      let regex = new RegExp("{(.*?)}", "g");
      let result;
      let array = [];

      while ((result = regex.exec(textReceived))) {
        let value = result[1];
        value = value.replace(
          "SYS.SOCIALNAME",
          createJSON(ContactId.cliente.trim())
        );
        value = value.replace(
          "SYS.NOMEAGENTE",
          createJSON(InfoUsers.displayname.trim())
        );

        value = value.replace("SYS.GREETING", createJSON(saudacao.trim()));
        value = value.replace("SYS.SAUDACAO", createJSON(saudacao.trim()));

        if (NpsDetails.length !== 0) {
          const filterNpsClientDetails = NpsDetails.filter(
            (nps) => nps.numero_cliente === ContactId.telefone
          );
          if (filterNpsClientDetails.length !== 0) {
            value = value.replace(
              "CAMP.NOMECLIENTE",
              createJSON(filterNpsClientDetails[0].nome_cliente)
            );
          }
        }

        if (ContactId.protocolo) {
          value = value.replace(
            "SYS.PROTOCOLO",
            createJSON(ContactId.protocolo.trim())
          );
        }
        array.push({
          id: result[1],
          name: result[1],
          value: value === result[1] ? "${" + value + "}" : value,
        }); // mostra o que está entre os :
      }

      if (
        array.length !== 0 &&
        (mimetypeid >= 30 || mimetypeid === 1) &&
        editable === true
      ) {
        MicroModal.show("modal__mensagens-predefinidas-monitoring");
        // this.setState({
        //   messageQuickAnswer: textReceived,
        //   variableQuickAnwser: array,
        // });
        setMessageQuickAnswer(textReceived);
        setVariableQuickAnwser(array);
      }
    } catch {
      console.log("ERROR");
    }

    document.getElementById("chat-message").innerText = texto;
    // this.props.editMsg(texto, ContactId.idatendimento);
    dispatch(editMsg(texto, ContactId.idatendimento));

    if (mimetypeid != 1) {
      if (mimetypeid >= 30 && mimetypeid <= 38) {
        // this.setState({
        //   isHSM: true,
        //   paramsHSM: resp,
        //   checkparam: checkvalueSName,
        //   checkparam2: checkvalueNAgent,
        // });
        setIsHSM(true);
        setParamsHSM(resp);
        setCheckparam(checkvalueSName);
        setCheckparam2(checkvalueNAgent);

        if (mimetypeid === 38 || mimetypeid === 31) {
          let arrayfile = [filepath, texto, mimetypeid];
          // this.setState({ fileasw: [] });
          // this.setState({ fileasw: arrayfile });
          setFileasw(arrayfile);
        }
      } else {
        let gerarnomearquivo = makeid(32);
        let photo = {
          uri: filepath,
          type: "application/pdf",
          name: gerarnomearquivo + ".pdf",
        };
        let fileencryp = new FormData();
        fileencryp.append("file", gerarnomearquivo + ".pdf");
        //fileencryp.append('file', photo, gerarnomearquivo+".pdf");
        let arrayfile = [filepath, texto, mimetypeid];
        // this.setState({ fileasw: [] });
        // this.setState({ fileasw: arrayfile });
        setFileasw(arrayfile);
      }
    } else {
      // this.setState({ fileasw: [] });
      setFileasw([]);
    }
    if (editable == false) {
      document.getElementById("chat-message").disabled = true;
      document.getElementById("chat-message").contentEditable = false;
      // this.setState({ editableQuickAnswer: true });
      setEditableQuickAnswer(true);
    } else {
      document.getElementById("chat-message").disabled = false;
      document.getElementById("chat-message").contentEditable = true;
      document.getElementById("chat-message").focus();
    }
    // this.setState({
    //   buttonQuickAnswer: !this.state.buttonQuickAnswer,
    //   searchQuickMsg: "",
    // });
    setButtonQuickAnswer(!buttonQuickAnswer);
    setSearchQuickMsg("");

    document.getElementById("input-msgs-rapidas").value = "";

    //this.setState({ fileasw: [] });
  };

  const filterList = (event, respostas) => {
    let updatedList = respostas;
    updatedList = updatedList.filter(function (item) {
      let asw = item.qck_asw_keyword;
      let filtro = event.target.value;
      let er = /[^a-z0-9]/gi;
      filtro = filtro.replace(er, "");
      let resultado = asw.search(filtro);
      return asw.toLowerCase().search(filtro.toLowerCase()) != -1;
    });
    // this.setState({ respostas: updatedList });
    setRespostas(updatedList);
  };

  const handleselectedFile = (event, infousers, contactid, line) => {
    let filesend = event.target.files[0];
    if (filesend != undefined) {
      // this.setState({
      //   selectedFile: filesend,
      //   loaded: 0,
      // });
      setSelectedFile(filesend);
      setLoaded(0);

      let data = new FormData();
      let namefile = filesend.name;
      let hora = moment().format("HH-mm-ss");
      let random = Math.floor(Math.random() * 999999 + 100000);
      random = random + "_" + hora;
      let ext = namefile.split(".").pop();
      namefile = random + "." + ext;
      data.append("file", filesend, namefile);
      let msgweb = document.getElementById("chat-message").innerText;
      let msgsocket = document.getElementById("chat-message").innerText;
      let str = msgsocket.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        document.getElementById("chat-message").innerHTML = "";
        // this.props.UploadFile(
        //   data,
        //   infousers,
        //   contactid,
        //   msgweb,
        //   makeid(32),
        //   filesend.size,
        //   line
        // );
        dispatch(
          InsertUploadMonitoring(
            data,
            infousers,
            contactid,
            msgweb,
            makeid(32),
            filesend.size,
            line
          )
        );
      } else {
        // this.props.UploadFile(
        //   data,
        //   infousers,
        //   contactid,
        //   "",
        //   makeid(32),
        //   filesend.size,
        //   line
        // );
        dispatch(
          InsertUploadMonitoring(
            data,
            infousers,
            contactid,
            "",
            makeid(32),
            filesend.size,
            line
          )
        );
      }
    }
    document.getElementById("file-input").value = "";
  };

  const audioStart = () => {
    // this.setState({
    //   record: true,
    //   timerecording: 0,
    // });
    setRecord(true);
    setTimerecording(0);
    if (isBlocked) {
    } else {
      Mp3Recorder.start()
        .then(() => {
          // this.setState({ isRecording: true });
          setIsRecording(true);
        })
        .catch((e) => console.error(e));
    }
  };

  const audioStopIn = () => {
    // this.setState({
    //   record: false,
    // });
    setRecord(false);
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        // const blobURL = URL.createObjectURL(blob)
        const blobURL = blob;
        // this.setState({ blobURL, isRecording: true });
        setBlobURL(blobURL);
        setIsRecording(true);
      })
      .catch((e) => console.log(e));
  };

  const audioStop = () => {
    // this.setState({
    //   record: false,
    //   blobURL: "",
    // });
    setRecord(false);
    setBlobURL("");
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        // this.setState({ isRecording: false });
        setIsRecording(false);
      })
      .catch((e) => console.log(e));
  };

  const sendTextInputChat = (textReceived) => {
    document.getElementById("chat-message").innerText = textReceived;
  };

  const actionSendMessageClient = (bind) => {
    MicroModal.close("modal__mensagens-predefinidas-monitoring");
    document.getElementById("button-send-message").click();
    document.getElementById("input-msgs-rapidas").value = "";
    // bind.setState({ searchQuickMsg: "" });
    setSearchQuickMsg("");
  };

  const actionCancelMessageClient = () => {
    MicroModal.close("modal__mensagens-predefinidas-monitoring");
    document.getElementById("chat-message").innerText = "";
  };

  const changeVariablesSending = (array) => {
    // arrayVariables = array;
    // document.getElementById("button-save-variables").click();
    setVariableQuickAnwser(array);
  };

  const renderChat = () => {
    if (selectedChat && parseInt(selectedChat.idmidia) === 3) {
      return MailMessage.filter(
        (message) => message.cdr === selectedChat.idatendimento
      ).map((mail) => (
        <MailContainer
          mail={mail}
          inputSearch={searchText}
          canFavorite={false}
        />
      ));
    } else if (monitorMessage.length > 0) {
      return (
        <MessageList
          arrayMessage={monitorMessage}
          selectedChat={selectedChat}
          agent={Monitoring.agent}
          searchText={searchText}
          handleAddContact={handleAddContact}
          canSaveContact={false}
        />
      );
    } else if (hasVoice && parseInt(selectedChat.idmidia) === 1) {
      return <AudioWaveform />;
    } else {
      return <p>Nenhuma mensagem encontrada para essa conversa.</p>;
    }
  };

  const renderTimeChat = (chat) => {
    const calculateTime = (date) => {
      let duracao = 0;
      let arrayCompA = date;
      let datatimeCompA = moment().format("YYYY/MM/DD HH:mm:ss");
      let dataStatusA = moment(arrayCompA, "DD/MM/YYYY HH:mm:ss").format(
        "YYYY/MM/DD HH:mm:ss"
      );

      var valorDiferenca = parseInt(
        Math.abs(Math.round(LoginCompleteReducer.difftime))
      );

      if (parseInt(LoginCompleteReducer.difftime) < 0) {
        datatimeCompA = moment()
          .subtract(valorDiferenca, "seconds")
          .format("YYYY/MM/DD HH:mm:ss");
      } else {
        datatimeCompA = moment()
          .add(valorDiferenca, "seconds")
          .format("YYYY/MM/DD HH:mm:ss");
      }

      duracao = moment(datatimeCompA).diff(dataStatusA, "seconds");
      duracao = duracao < 0 ? 0 : duracao;
      return duracao;
    };

    const convertDays = (totalSeconds) => {
      const secondsInDay = 86400;
      const days = Math.floor(totalSeconds / secondsInDay);

      return days;
    };
    // <span>{chat.recuperationtime}</span>
    const tempoMaximo = calculateTime(chat.recuperationtime);
    const dias = convertDays(tempoMaximo);

    return (
      <TimeCounterMinute
        horario={parseInt(tempoMaximo)}
        key={chat.idatendimento}
        day={dias}
      />
    );
  };

  const DisplayHistoric = (e, telefone, cdrid) => {
    e.preventDefault();
    const agora = moment().subtract(7, "days");
    let datainit = agora.format("YYYY-MM-DDT00:00");
    let datafim = moment().format("YYYY-MM-DDT23:59");
    let today = moment().format("YYYY-MM-DD");
    let idgroup = InfoUsers.idgroup;

    // if (this.state.buttonAnnotations === false) {
    SearchHistory(e, telefone, cdrid, datainit, datafim);
    dispatch(
      InteracoesContactNumber(
        telefone.substr(2),
        datainit,
        datafim,
        "",
        idgroup
      )
    );
    // this.setState({ dateinit: datainit, dateend: datafim });
    // }
  };

  const SearchHistory = (e, telefone, cdrid, datainit, datafim) => {
    let histstart = datainit;
    let histend = datafim;
    let idgroup = InfoUsers.idgroup;
    dispatch(
      SearchingHistoryData(histstart, histend, cdrid, telefone, idgroup)
    );
    // this.setState({
    //   clientpdf: telefone,
    //   datapdfend: histend,
    //   datapdfinit: histend,
    //   cliente: telefone,
    // });
  };

  const buttonSearchMarkstar = (e, telefone) => {
    e.preventDefault();
    let erro = 0;
    // let datainit = this.dataInitMark.value;
    // let datafim = this.dataFimMark.value;

    let now = moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = moment().format("YYYY-MM-DD");

    const comparation = moment(datainit).isBefore(datafim);

    if (datainit == "") erro = 1;

    if (datafim == "") erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(DetailsMarkstarida(datainit, datafim, telefone));
    }
  };

  const buttonSearchFileCompart = (e, telefone) => {
    e.preventDefault();
    let erro = 0;
    let now = moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = moment().format("YYYY-MM-DD");
    const formats =
      "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28";
    const midias = "2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18";

    const comparation = moment(datainit).isBefore(datafim);

    if (datainit == "") erro = 1;

    if (datafim == "") erro = 1;

    if (formats == "") erro = 1;

    if (midias == "") erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(DetailsFileShared(datainit, datafim, formats, midias, telefone));
    }
  };

  const ShowModals = (e, modal, telefone, cdrid, contactName) => {
    //Função que seta o nome e o número do contato pros modais
    dispatch(GetInteractionsModal(contactName, telefone));
    //
    switch (modal) {
      case "modal__anotacoes-details":
        MicroModal.show("modal__anotacoes-details-new");
        // buttonSearchAnotation(e, telefone);
        break;
      case "modal__arquivos-compartilhados-details":
        MicroModal.show("modal__arquivos-compartilhados-details");
        // buttonSearchFileCompart(e, telefone);
        break;
      case "modal__mensagens-favoritas-details":
        MicroModal.show("modal__mensagens-favoritas-details");
        // buttonSearchMarkstar(e, telefone);
        break;
      case "modal__historico-atendimento-details":
        MicroModal.show("modal__historico-atendimento-details");
        SearchHistory(e, telefone, cdrid);
        break;
      case "modal__agenda-pf__cliente__interacoes_history":
        MicroModal.show("modal__historico-atendimento-details");
        // DisplayHistoric(e, telefone, cdrid);
        break;
      default:
        break;
    }
  };

  const getTermText = (event) => {
    setSearchText(event.target.value);

    setTimeout(() => {
      const elems = document.getElementsByTagName("mark");
      const tam = elems.length;
      let expandLess = 0;
      // arrowterm = 0;

      // this.setState({
      //   searchText: event.target.value,
      //   arrowterm: 0,
      //   expand_more_count: tam,
      // });

      // if (tam !== 0) {
      //   expandLess = 1;
      // }

      setSearchWord({ total: tam, atual: expandLess });
    }, 100);
  };

  const handleKeyUp = (direction) => {
    const elems = document.getElementsByTagName("mark");
    const total = elems.length;
    let current = searchWord.atual;

    if (total === 0) return;

    if (direction === "less") {
      current = (current - 1 + total) % total;
    } else if (direction === "more") {
      current = (current + 1) % total;
    }
    setSearchWord({ ...searchWord, atual: current });
    elems[current].scrollIntoView({ block: "center", behavior: "smooth" });
  };

  const getVoiceChannel = (todos) => {
    let aux = todos ? todos.split("¿") : [];
    if (aux.length > 0) {
      let voiceCall = aux.filter((todo) => {
        return todo.split("§")[0] === "1";
      });

      if (voiceCall.length > 0) {
        setHasVoice({ cliente: voiceCall[0].split("§")[1] });
      } else {
        setHasVoice(false);
      }
    }
  };

  const renderInputChat = () => {
    if (typeMonitoring === 2 || typeMonitoring === 3) {
      if (
        (selectedChat && parseInt(selectedChat.idmidia) !== 3) ||
        !selectedChat
      ) {
        return (
          <div className="message-box">
            <div className="input-message">
              {(() => {
                if (Monitoring.line === "2") {
                  return (
                    <div className="monitoria-icon">
                      <SussurroIcon />
                    </div>
                  );
                } else if (Monitoring.line === "3") {
                  return (
                    <div className="monitoria-icon">
                      <PointMessageIcon />
                    </div>
                  );
                }
              })()}
              <div
                onKeyPress={handleKeyPress}
                autoComplete="off"
                type="text"
                // ref={(node) => (this.node = node)}
                onInput={(e) => (valorInput = e.target.innerText)}
                onKeyDown={handleKeyDown}
                onKeyUp={(event) =>
                  handleOnChange(
                    event,
                    InfoUsers,
                    selectedChat,
                    Monitoring.line
                  )
                }
                className="chat-message"
                id="chat-message"
                contentEditable="true"
              ></div>
              <div className={record ? "actions-chat" : "actions-chat active"}>
                <a
                  onClick={(e) => DisplayQuickAnswer(e)}
                  className={`btn action with-icon ${
                    buttonQuickAnswer ? "active" : ""
                  } `}
                  id="action-premade-messages"
                  data-tippy="Mensagens predefinidas"
                  href="#"
                >
                  <MensagemPredefinidas />
                </a>
                <div
                  className={
                    buttonQuickAnswer ? "premade-msg active" : "premade-msg"
                  }
                >
                  <p className="premade-msg__title">Mensagens Predefinidas</p>
                  <div className="premade-msg__content">
                    <ul className="premade-msg__list">
                      {respostas.map((resp) => (
                        <li
                          key={resp.qck_asw_id}
                          className="premade-msg__item"
                          onClick={(event) =>
                            InsertQuickAnswer(
                              event,
                              resp.qck_asw_answer,
                              resp.editable,
                              resp.mimetypeid,
                              resp.filepath,
                              InfoUsers,
                              selectedChat
                            )
                          }
                        >
                          {resp.qck_asw_keyword}
                        </li>
                      ))}
                    </ul>
                    <div className="premade-msg__input-wrapper">
                      <input
                        type="text"
                        className="premade-msg__search-input"
                        id="input-msgs-rapidas"
                        onChange={(event) =>
                          filterList(event, respostasinicial)
                        }
                        placeholder="Pesquise uma resposta..."
                      />
                      <span className="premade-msg__input-icon">
                        <i className="material-icons">search</i>
                      </span>
                    </div>
                  </div>
                </div>
                <QuickAnswer
                  message={messageQuickAnswer}
                  variables={variableQuickAnwser}
                  sendTextInputChat={sendTextInputChat}
                  actionSendMessageClient={actionSendMessageClient}
                  actionCancelMessageClient={actionCancelMessageClient}
                  changeVariablesSending={changeVariablesSending}
                  screen="monitoring"
                  bind={this}
                />
                <a
                  href="#"
                  className="btn action with-icon chat-special tippy-default"
                  data-tippy-theme="light"
                  id="action-attachment"
                  data-tippy-content="Adicionar Anexo"
                >
                  <label htmlFor="file-input">
                    <AnexarItem />
                    {/* attach_file */}
                  </label>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    name="upload"
                    id="file-input"
                    onChange={(event) =>
                      handleselectedFile(
                        event,
                        InfoUsers,
                        selectedChat,
                        Monitoring.line
                      )
                    }
                  />
                </a>
                <Tooltippy content={"Enviar Áudio"}>
                  <button
                    href="#"
                    onClick={audioStart}
                    disabled={!InfoUsers.sending_audio}
                    className="btn action with-icon"
                    id="action-voice"
                    data-tippy="Atender em voz"
                  >
                    <IconAudio />
                  </button>
                </Tooltippy>
              </div>
              <div className={record ? "active-voice active" : "active-voice"}>
                <a onClick={audioStop} className="cancel">
                  <i className="material-icons">close</i>
                </a>

                <div className="active-chats__timer active-chats__timer--active-voice">
                  {(() => {
                    if (record === true)
                      return (
                        <>
                          <span className="active-chats__timer-icon active-chats__timer--active-voice-icon alta">
                            •
                          </span>
                          <TimeCounter horario={timerecording} />
                        </>
                      );
                  })()}
                </div>

                <a onClick={audioStopIn} className="done">
                  <i className="material-icons">done</i>
                </a>
              </div>
            </div>

            <button
              type="submit"
              onClick={(event) =>
                ButtonSendMessage(
                  event,
                  "Me",
                  InfoUsers,
                  selectedChat,
                  "0",
                  Monitoring.line
                )
              }
              className="send-message"
              id="button-send-message"
            >
              {/* <i className="material-icons">send</i> */}
              <SEND />
            </button>
          </div>
        );
      }
    }

    return "";
  };

  const handleScroll = (direction) => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    const chatWidth = 265;
    const visibleItems = Math.floor(carousel.offsetWidth / chatWidth);
    const totalItems = arrayChats.length + (hasVoice ? 1 : 0);

    if (direction === "left" && scrollIndex > 0) {
      setScrollIndex(scrollIndex - 1);
    } else if (
      direction === "right" &&
      scrollIndex + visibleItems < totalItems
    ) {
      const maxScrollIndex = Math.max(totalItems - visibleItems, 0);
      setScrollIndex(Math.min(scrollIndex + 1, maxScrollIndex));
      // setScrollIndex(scrollIndex + 1);
    }
  };

  useEffect(() => {
    if (attendant.iduser) {
      MicroModal.show("modal__monitoring-dashboard");
      setSaveAttendant(attendant);
      setTypeMonitoring(parseInt(attendant.monitoringLine));
      // getVoiceChannel(attendant.jsoncall);
      dispatch(RespostasRapidasida(InfoUsers.id));
      // InitialMonitoringAction(
      //   InfoUsers.id,
      //   attendant.iduser,
      //   attendant.label,
      //   MonitoringSimult,
      //   attendant.monitoringLine,
      //   attendant.ramal
      // );

      // else if (saveAttendant && saveAttendant.iduser === attendant.iduser) {
      //   getVoiceChannel(infoJson);
      // }
    }
  }, [attendant]);

  useEffect(() => {
    getVoiceChannel(infoJson);
  }, [infoJson]);

  useEffect(() => {
    if (selectedChat) {
      const messages = Messages[selectedChat.idatendimento];
      setMonitorMessage(messages && messages.length > 0 ? messages : []);
    } else {
      setMonitorMessage([]);
    }
  }, [Messages, selectedChat]);

  useEffect(() => {
    const filterClients = ClientUserMonitors.filter(
      (client) => parseInt(Monitoring.userout) === parseInt(client.monuser)
    );
    setArrayChats([...filterClients]);

    if (
      attendant &&
      parseInt(attendant.monitoringLine) > 1 &&
      filterClients.length > 0
    ) {
      setSelectedChat(filterClients[0]);
    }

    if (filterClients.length === 0 && selectedChat && !hasVoice) {
      closeModal("modal__monitoring-dashboard");
    }
  }, [ClientUserMonitors]);

  useEffect(() => {
    if (blobURL && isRecording === true) {
      let data = new FormData();
      let hora = moment().format("HH-mm-ss");
      let random = Math.floor(Math.random() * 999999 + 100000);
      random = random + "_" + hora;
      let namefile = random + ".mp3";
      data.append("file", blobURL, namefile);
      const AudioFile = data;

      dispatch(
        InsertUploadMonitoring(
          AudioFile,
          InfoUsers,
          selectedChat,
          "",
          makeid(32),
          blobURL.size,
          Monitoring.line
        )
      );
      setBlobURL("");
    }
  }, [blobURL, isRecording]);

  useEffect(() => {
    let history = [...History];
    let historyRecent = [...History];
    let totalhistory = 0;

    if (History.lenght !== 0) {
      historyRecent = historyRecent.filter((history) =>
        [1].includes(history.mimetypeid)
      );
      if (historyRecent.lenght === 0) {
        historyRecent = [];
      }
      if (history[0] != undefined) {
        totalhistory = history[0].interacoes;
      }
    } else {
      history = [];
      historyRecent = [];
    }

    setHistoryInfo({ history, historyRecent, totalhistory });
  }, [History]);

  useEffect(() => {
    if (!hasVoice && selectedChat && selectedChat.idatendimento === "voice") {
      if (arrayChats.length > 0) {
        setSelectedChat(arrayChats[0]);
      } else {
        closeModal("modal__monitoring-dashboard");
      }
    }
  }, [hasVoice]);

  useEffect(() => {
    if (MonitoringSimult.length === 0) {
      MicroModal.close("modal__monitoring-dashboard");
    }
  }, [MonitoringSimult]);

  // console.log("VEIO AQ1", MonitoringSimult);
  // console.log("VEIO AQ1.1", Monitoring);
  // console.log("VEIO AQ2", ClientUserMonitors);
  // console.log("VEIO AQ3", RespostasRapidas);
  // console.log("VEIO AQ4", Messages);
  // console.log("VEIO AQ5", attendant);
  // console.log("VEIO AQ6", DetailsFileSharedIn);

  return (
    <>
      <div
        className="modal micromodal-slide"
        id="modal__monitoring-dashboard"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container monitoring-dashboard__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="monitoring-dashboard__container"
          >
            <div className="monitoring-dashboard">
              <header className="dashboard-header">
                <Typography.H2 color={"gray-600"} weight={600}>
                  Monitoria
                </Typography.H2>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    closeModal("modal__monitoring-dashboard");
                  }}
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                  ref={closeRef}
                ></button>
              </header>

              <main>
                <div className={`container`}>
                  <div className="top-bar">
                    <div className="user-info">
                      <UserPhoto size="large" />
                      <Typography.H4 color={"gray-600"}>
                        {attendant.label}
                      </Typography.H4>
                      {/* <span className="user-name">Alan Carvalho</span> */}
                    </div>
                    <div className="action-buttons">
                      <Tooltippy content={"Falar com atendente"}>
                        <button
                          className={`action-button ${
                            typeMonitoring === 0 ? "active" : ""
                          } ${hasVoice ? "disabled" : ""}`}
                          onClick={() => {
                            setTypeMonitoring(0);
                            InitialCall(ChatSimult, attendant);
                          }}
                        >
                          <CallIcon />
                        </button>
                      </Tooltippy>

                      <Tooltippy content={"Escuta sigilosa"}>
                        <button
                          className={`action-button ${
                            typeMonitoring === 1 ? "active" : ""
                          }`}
                          onClick={() => {
                            setTypeMonitoring(1);
                            InitialMonitoringAction(
                              InfoUsers.id,
                              attendant.iduser,
                              attendant.label,
                              MonitoringSimult,
                              "1",
                              attendant.ramal
                            );
                          }}
                        >
                          <ListeningIcon />
                        </button>
                      </Tooltippy>

                      <Tooltippy content={"Sussuro"}>
                        <button
                          className={`action-button ${
                            typeMonitoring === 2 ? "active" : ""
                          } ${
                            (selectedChat &&
                              parseInt(selectedChat.idmidia) === 3) ||
                            (selectedChat &&
                              parseInt(selectedChat.idmidia) === 1)
                              ? "disabled"
                              : ""
                          }`}
                          onClick={() => {
                            if (!selectedChat) {
                              setSelectedChat(ClientUserMonitors[0]);
                            }
                            setTypeMonitoring(2);
                            InitialMonitoringAction(
                              InfoUsers.id,
                              attendant.iduser,
                              attendant.label,
                              MonitoringSimult,
                              "2",
                              attendant.ramal
                            );
                          }}
                        >
                          <SussurroIcon />
                        </button>
                      </Tooltippy>

                      <Tooltippy content={"Intercalar"}>
                        <button
                          className={`action-button ${
                            typeMonitoring === 3 ? "active" : ""
                          } ${
                            (selectedChat &&
                              parseInt(selectedChat.idmidia) === 3) ||
                            (selectedChat &&
                              parseInt(selectedChat.idmidia) === 1)
                              ? "disabled"
                              : ""
                          }`}
                          onClick={() => {
                            if (!selectedChat) {
                              setSelectedChat(ClientUserMonitors[0]);
                            }
                            setTypeMonitoring(3);
                            InitialMonitoringAction(
                              InfoUsers.id,
                              attendant.iduser,
                              attendant.label,
                              MonitoringSimult,
                              "3",
                              attendant.ramal
                            );
                          }}
                        >
                          <PointMessageIcon />
                        </button>
                      </Tooltippy>

                      {selectedChat &&
                        !openDetails &&
                        parseInt(selectedChat.idmidia) !== 1 && (
                          <Tooltippy content={"Detalhes"}>
                            <button
                              className={`action-button`}
                              onClick={() => {
                                setOpenDetails(true);
                              }}
                            >
                              <InfoCircle />
                            </button>
                          </Tooltippy>
                        )}
                    </div>
                  </div>

                  <div className="chat-container">
                    <div className="chat-carousel">
                      <button
                        className="carousel-btn left-btn"
                        onClick={() => handleScroll("left")}
                        disabled={scrollIndex === 0}
                      >
                        {/* {"<"} */}
                        <ArrowLeft />
                      </button>
                      <div className="chat-list-wrapper">
                        <div
                          className="chat-list"
                          ref={carouselRef}
                          style={{
                            transform: `translateX(-${scrollIndex * 230}px)`,
                          }}
                        >
                          {hasVoice ? (
                            <div
                              className={`chat-item ${
                                selectedChat &&
                                selectedChat.idatendimento === "voice"
                                  ? "active"
                                  : ""
                              }`}
                              onClick={(e) => {
                                // e.preventDefault();
                                setSelectedChat({
                                  idatendimento: "voice",
                                  idmidia: "1",
                                });
                                if (openSearch) {
                                  setOpenSearch(false);
                                }
                                if (typeMonitoring !== 1) {
                                  setTypeMonitoring(1);
                                  InitialMonitoringAction(
                                    InfoUsers.id,
                                    attendant.iduser,
                                    attendant.label,
                                    MonitoringSimult,
                                    "1",
                                    attendant.ramal
                                  );
                                }
                              }}
                            >
                              <Tooltippy
                                content={
                                  "Esse atendente está em uma chamada de voz"
                                }
                                allowHTML
                                theme="translucent-modal"
                              >
                                <div className="chat-icon">
                                  <UserPhoto size="large" />
                                  {getMediaIcon(1)}
                                </div>
                                <div className="chat-info">
                                  <p className="name-info">
                                    {createJSON(hasVoice.cliente)}
                                  </p>
                                </div>
                              </Tooltippy>
                            </div>
                          ) : (
                            ""
                          )}
                          {arrayChats.map((chat) => (
                            <div
                              key={chat.idatendimento}
                              className={`chat-item ${
                                selectedChat &&
                                selectedChat.idatendimento ===
                                  chat.idatendimento
                                  ? "active"
                                  : ""
                              }`}
                              onClick={(e) => {
                                // e.preventDefault();
                                setSelectedChat(chat);
                                if (openSearch) {
                                  setOpenSearch(false);
                                }
                                if (
                                  parseInt(chat.idmidia) === 3 &&
                                  typeMonitoring !== 1
                                ) {
                                  setTypeMonitoring(1);
                                  InitialMonitoringAction(
                                    InfoUsers.id,
                                    attendant.iduser,
                                    attendant.label,
                                    MonitoringSimult,
                                    "1",
                                    attendant.ramal
                                  );
                                }
                              }}
                            >
                              <Tooltippy
                                content={exibInfosContact(chat)}
                                allowHTML
                                theme="translucent-modal"
                              >
                                <div className="chat-icon">
                                  <UserPhoto size="large" />
                                  {getMediaIcon(chat.idmidia)}
                                </div>
                                <div className="chat-info">
                                  <p className="name-info">
                                    {createJSON(chat.cliente)}
                                  </p>
                                  <p className="time-cont">
                                    <span className="time-point"></span>
                                    {renderTimeChat(chat)}
                                  </p>
                                </div>
                              </Tooltippy>
                              <Tippy
                                content={exibActionsContact(
                                  chat.telefone,
                                  chat.cliente,
                                  chat.idatendimento,
                                  InfoUsers,
                                  chat.monuser,
                                  chat.serverid,
                                  chat
                                )}
                                trigger="click"
                                placement="top"
                                theme="actions-modal"
                              >
                                <ActionIcon
                                  width="17"
                                  className="action-icon"
                                />
                              </Tippy>
                            </div>
                          ))}
                        </div>
                      </div>
                      <button
                        className="carousel-btn right-btn"
                        onClick={() => handleScroll("right")}
                        disabled={
                          !carouselRef.current ||
                          scrollIndex +
                            Math.floor(carouselRef.current.offsetWidth / 265) >=
                            arrayChats.length + (hasVoice ? 1 : 0)
                        }
                      >
                        {/* {">"} */}
                        <ArrowLeft />
                      </button>
                    </div>

                    <div
                      className={`chat-search ${openSearch ? "is-active" : ""}`}
                    >
                      <div className="search-box-content-input">
                        <input
                          type="text"
                          autoFocus={true}
                          onChange={(event) => getTermText(event)}
                          value={searchText}
                          placeholder="Pesquisar mensagens..."
                          className="search-input"
                        />

                        <div className="block-header__search-box-content-count">
                          {searchWord.total === 0
                            ? searchWord.atual
                            : searchWord.atual + 1}{" "}
                          de {searchWord.total}
                        </div>
                      </div>

                      <div className="search-box-content-icon">
                        <a
                          onClick={(event) => handleKeyUp("less")}
                          className="block-header__search-box-icon material-icons"
                        >
                          expand_less
                        </a>
                        <a
                          onClick={(event) => handleKeyUp("more")}
                          className="block-header__search-box-icon material-icons"
                        >
                          expand_more
                        </a>
                      </div>
                      <button
                        onClick={() => {
                          setSearchText("");
                          setOpenSearch(false);
                          setSearchWord({ atual: 0, total: 0 });
                        }}
                        className="search-box-button"
                      >
                        <Typography.H5 color={"white"} weight={"700"}>
                          Concluir
                        </Typography.H5>
                      </button>
                    </div>

                    <div className="chat-window">
                      {
                        selectedChat ? (
                          renderChat()
                        ) : (
                          <p>Nenhuma mensagem selecionada desse atendente.</p>
                          // <AudioWaveform />
                        )
                        // audioElement && (
                        //   <AudioVisualizer />
                        // )
                      }
                    </div>
                    {renderInputChat()}
                  </div>
                </div>
                {selectedChat && openDetails && (
                  <div className="container-details">
                    <div className="details-line">
                      <div className="details-line__header">
                        <Typography.H4 weight={700} color={"blue-selected-4"}>
                          Detalhes
                        </Typography.H4>
                        <LoginSvg
                          className="close-details"
                          onClick={() => {
                            setOpenDetails(false);
                          }}
                        />
                      </div>
                    </div>
                    <div className="details-line">
                      <Typography.H4 weight={700} color={"blue-selected-4"}>
                        {createJSON(selectedChat.cliente)}
                      </Typography.H4>
                    </div>
                    <div className="details-line">
                      <ul className="details__info-list">
                        {selectedChat.idmidia !== "3" && (
                          <li className="details__info-item">
                            <Typography.H4 weight={700} color={"black"}>
                              Telefone:
                            </Typography.H4>
                            <Typography.H4 weight={400} color={"black"}>
                              {selectedChat.telefone}
                            </Typography.H4>
                          </li>
                        )}
                        <li className="details__info-item">
                          <Typography.H4 weight={700} color={"black"}>
                            Data do contato:{" "}
                          </Typography.H4>

                          <Typography.H4 weight={400} color={"black"}>
                            {selectedChat.datatimeatd}
                          </Typography.H4>
                        </li>
                        <li className="details__info-item">
                          <Typography.H4 weight={700} color={"black"}>
                            Motivo:
                          </Typography.H4>

                          <Typography.H4 weight={400} color={"black"}>
                            {parseInt(selectedChat.direction) === 1
                              ? selectedChat.nomesubservico
                              : selectedChat.servico}
                          </Typography.H4>
                        </li>
                        <br />
                        <br />
                        <li className="details__info-item">
                          <Typography.H4 weight={700} color={"black"}>
                            Informações
                          </Typography.H4>

                          <ul className="details__info-inner-list">
                            {(() => {
                              if (
                                selectedChat.protocolo !== null &&
                                selectedChat.protocolo !== undefined &&
                                selectedChat.protocolo !== ""
                              ) {
                                return (
                                  <li className="details__info-inner-item">
                                    <Typography.H4 weight={700} color={"black"}>
                                      {"Protocolo : "}
                                    </Typography.H4>

                                    <Typography.H4 weight={400} color={"black"}>
                                      {selectedChat.protocolo}
                                    </Typography.H4>
                                  </li>
                                );
                              }
                            })()}

                            {(() => {
                              if (
                                selectedChat.datatachado != undefined &&
                                selectedChat.datatachado !== "" &&
                                selectedChat.datatachado !== null
                              ) {
                                if (isJson(selectedChat.datatachado) === true) {
                                  let strDtch = selectedChat.datatachado;
                                  return Object.keys(strDtch).map((key) => (
                                    <li className="details__info-inner-item">
                                      <Typography.H4
                                        weight={700}
                                        color={"black"}
                                      >
                                        {key + ":"}
                                      </Typography.H4>

                                      <Typography.H4
                                        weight={400}
                                        color={"black"}
                                      >
                                        {strDtch[key]}
                                      </Typography.H4>
                                    </li>
                                  ));
                                }
                              }
                            })()}
                            {/* DDI_E164: 5568992135836 */}
                            {/* Dados não coletados */}

                            {selectedChat.menubot
                              .split("~¿")
                              .map((bot, index) => {
                                const separator = bot.split(":");

                                if (separator[0]) {
                                  return (
                                    <li
                                      key={index}
                                      className="details__info-inner-item"
                                    >
                                      <Typography.H4
                                        weight={700}
                                        color={"black"}
                                      >
                                        {`${createJSON(separator[0])}: `}
                                      </Typography.H4>
                                      {separator[1] ? (
                                        separator[1].length > 21 ? (
                                          <Tooltippy
                                            content={
                                              separator[1].length > 21
                                                ? createJSON(separator[1])
                                                : ""
                                            }
                                          >
                                            <Typography.H4
                                              weight={400}
                                              color={"black"}
                                            >
                                              {separator[1].length > 21
                                                ? `${createJSON(
                                                    separator[1]
                                                  ).slice(0, 21)}
                                                          ...`
                                                : createJSON(separator[1])}
                                            </Typography.H4>
                                          </Tooltippy>
                                        ) : (
                                          <Typography.H4
                                            weight={400}
                                            color={"black"}
                                          >
                                            {createJSON(separator[1])}
                                          </Typography.H4>
                                        )
                                      ) : (
                                        ""
                                      )}
                                    </li>
                                  );
                                }
                              })}

                            {(() => {
                              if (
                                connection_platform.nc2_integration === true &&
                                connection_platform.nc2_users.indexOf(
                                  InfoUsers.ramal
                                ) !== -1
                              ) {
                                if (
                                  InfoUsers.infoclinc2.length !== 0 &&
                                  selectedChat.isDialNc2
                                ) {
                                  return InfoUsers.infoclinc2.map((info) => (
                                    <li className="details__info-inner-item">
                                      <Typography.H4
                                        weight={700}
                                        color={"black"}
                                      >
                                        {info}
                                      </Typography.H4>
                                    </li>
                                  ));
                                }
                              }
                            })()}
                          </ul>
                        </li>
                        {/* )} */}
                      </ul>
                    </div>
                    <div
                      className={`details-line ${
                        detailsOptions.interactions ? "open" : ""
                      }`}
                      onClick={(event) => {
                        if (!detailsOptions.interactions) {
                          DisplayHistoric(
                            event,
                            selectedChat.telefone,
                            selectedChat.idatendimento
                          );
                        }

                        setDetailsOptions({
                          ...detailsOptions,
                          interactions: !detailsOptions.interactions,
                        });
                      }}
                    >
                      <div className="details-line__header">
                        <Typography.H4 weight={700} color={"blue-selected-4"}>
                          Interações
                        </Typography.H4>
                        <ArrowDown />
                      </div>
                      <div
                        // className={
                        //   this.state.buttonHistoric
                        //     ? "anotc__recent-content active"
                        //     : "anotc__recent-content"
                        // }
                        style={{
                          display: detailsOptions.interactions
                            ? "flex"
                            : "none",
                          flexDirection: "column",
                        }}
                      >
                        {(() => {
                          if (
                            historyInfo &&
                            historyInfo.historyRecent.length !== 0
                          ) {
                            var cliente = createJSON(selectedChat.cliente);
                            var mensagem = createJSON(
                              historyInfo.historyRecent[0].messagem
                            );
                            var idmidia = historyInfo.historyRecent[0].idmidia;
                            var data_envio =
                              historyInfo.historyRecent[0].dataenvio +
                              "-" +
                              historyInfo.historyRecent[0].horaenvio;
                            var agente = historyInfo.historyRecent[0].agente;
                            let textFormatted = unicodeToChar(mensagem);
                            textFormatted = tratarUnderline(textFormatted);
                            return (
                              <div>
                                <div className="msg-fav__mp-bubble recent">
                                  <div
                                    className=" msg-fav__mp-bubble--recent"
                                    style={{ pointerEvents: "none" }}
                                  >
                                    {ReactHtmlParser(`<p>${textFormatted}</p>`)}
                                  </div>
                                </div>
                                <div className="anotc__mp-result-item-top padding">
                                  <div className="anotc__mp-result-item-info--recent no-padding">
                                    <p className="anotc__mp-result-item-name small">
                                      {cliente}
                                    </p>
                                    {(() => {
                                      if (agente === false) {
                                        return (
                                          <p className="anotc__mp-result-item-title small">
                                            Cliente
                                          </p>
                                        );
                                      } else {
                                        return (
                                          <p className="anotc__mp-result-item-title small">
                                            Atendente
                                          </p>
                                        );
                                      }
                                    })()}
                                  </div>
                                  <div className="anotc__mp-result-item-critic med">
                                    {(() => {
                                      getMediaIcon(idmidia);
                                    })()}

                                    {data_envio}
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })()}

                        <div
                          className="anotc__mp-result-btn--recent"
                          onClick={(event) =>
                            ShowModals(
                              event,
                              "modal__agenda-pf__cliente__interacoes_history",
                              selectedChat.telefone,
                              selectedChat.idatendimento,
                              selectedChat.cliente
                            )
                          }
                        >
                          Ver tudo
                        </div>
                      </div>
                    </div>
                    <div
                      className={`details-line ${
                        detailsOptions.notes ? "open" : ""
                      }`}
                      onClick={(e) => {
                        if (!detailsOptions.notes) {
                          buttonSearchAnotation(e, selectedChat.telefone);
                        }
                        setDetailsOptions({
                          ...detailsOptions,
                          notes: !detailsOptions.notes,
                        });
                      }}
                    >
                      <div className="details-line__header">
                        <Typography.H4 weight={700} color={"blue-selected-4"}>
                          Anotações
                        </Typography.H4>
                        <ArrowDown />
                      </div>
                      <div
                        // className={
                        //   this.state.buttonAnnotations
                        //     ? "anotc__recent-content active"
                        //     : "anotc__recent-content"
                        // }
                        style={{
                          display: detailsOptions.notes ? "flex" : "none",
                          flexDirection: "column",
                        }}
                      >
                        {(() => {
                          if (
                            DetailsAnotations.detailsanotations &&
                            DetailsAnotations.detailsanotations.length !== 0
                          ) {
                            var cliente = createJSON(selectedChat.cliente);
                            var nameC =
                              DetailsAnotations.detailsanotations[0]
                                .usuario_anotacao;
                            var classe =
                              DetailsAnotations.detailsanotations[0]
                                .class_criticality;
                            var criticidade =
                              DetailsAnotations.detailsanotations[0]
                                .desc_criticidade;
                            var datahora =
                              DetailsAnotations.detailsanotations[0]
                                .data_anotacao +
                              " - " +
                              DetailsAnotations.detailsanotations[0]
                                .hora_anotacao;
                            var atendente =
                              DetailsAnotations.detailsanotations[0]
                                .usuario_anotacao;
                            var texto =
                              DetailsAnotations.detailsanotations[0]
                                .desc_anotacao;
                            return (
                              <div>
                                <div className="anotc__mp-result-item-top padding-bottom">
                                  <button className="anotc__mp-result-avatar anotc__mp-result-avatar--recent">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="10.06"
                                      height="11.807"
                                      viewBox="0 0 10.06 11.807"
                                    >
                                      <g transform="translate(0 0)">
                                        <ellipse
                                          cx="2.775"
                                          cy="2.738"
                                          rx="2.775"
                                          ry="2.738"
                                          transform="translate(2.255)"
                                          fill="#b7bec5"
                                        />
                                        <path
                                          d="M5.03,0A5,5,0,0,0,0,4.962H10.06A5,5,0,0,0,5.03,0Z"
                                          transform="translate(0 6.844)"
                                          fill="#b7bec5"
                                        />
                                      </g>
                                    </svg>
                                  </button>

                                  <div className="anotc__mp-result-item-info--recent">
                                    <p className="anotc__mp-result-item-name">
                                      {cliente}
                                    </p>
                                    <p className="anotc__mp-result-item-title">
                                      {nameC}
                                    </p>
                                  </div>
                                  <div className="anotc__mp-result-item-critic">
                                    <span
                                      className={
                                        "anotc__mp-result-item-level " + classe
                                      }
                                    >
                                      {criticidade}
                                    </span>
                                  </div>
                                </div>

                                <div className="anotc__mp-result-item-critic">
                                  <span className="anotc__mp-result-item-fulltime">
                                    {datahora}
                                  </span>
                                </div>
                                <div className="anotc__mp-result-item-content recent">
                                  {texto}
                                </div>
                              </div>
                            );
                          }
                        })()}
                        <div
                          className="anotc__mp-result-btn--recent"
                          onClick={(event) =>
                            ShowModals(
                              event,
                              "modal__anotacoes-details",
                              selectedChat.telefone,
                              selectedChat.idatendimento,
                              selectedChat.cliente
                            )
                          }
                        >
                          Ver tudo
                        </div>
                      </div>
                    </div>
                    <div
                      className={`details-line ${
                        detailsOptions.favMsg ? "open" : ""
                      }`}
                      onClick={(e) => {
                        if (!detailsOptions.favMsg) {
                          buttonSearchMarkstar(e, selectedChat.telefone);
                        }

                        setDetailsOptions({
                          ...detailsOptions,
                          favMsg: !detailsOptions.favMsg,
                        });
                      }}
                    >
                      <div className="details-line__header">
                        <Typography.H4 weight={700} color={"blue-selected-4"}>
                          Mensagens Favoritas
                        </Typography.H4>
                        <ArrowDown />
                      </div>
                      <div
                        // className={
                        //   this.state.buttonSpotlight
                        //     ? "anotc__recent-content active"
                        //     : "anotc__recent-content"
                        // }
                        style={{
                          display: detailsOptions.favMsg ? "flex" : "none",
                          flexDirection: "column",
                        }}
                      >
                        {(() => {
                          if (
                            DetailsMarkstar.detailsmarkstars &&
                            DetailsMarkstar.detailsmarkstars.length !== 0
                          ) {
                            const detailsMarkstars =
                              DetailsMarkstar.detailsmarkstars.filter(
                                (details) => [1].includes(details.mimetypeid)
                              );
                            var cliente = createJSON(selectedChat.cliente);
                            var mensagem = detailsMarkstars[0].mensagem;
                            var idmidia = detailsMarkstars[0].idmidia;
                            var data_envio =
                              detailsMarkstars[0].data_markstar +
                              "-" +
                              detailsMarkstars[0].data_markstar;
                            return (
                              <div>
                                <div className="msg-fav__mp-bubble recent">
                                  <div className=" msg-fav__mp-bubble--recent">
                                    {mensagem}
                                  </div>
                                  <span className="msg-fav__mp-star material-icons">
                                    star
                                  </span>
                                </div>
                                <div className="anotc__mp-result-item-top padding">
                                  <div className="anotc__mp-result-item-info--recent no-padding">
                                    <p className="anotc__mp-result-item-name small">
                                      {cliente}
                                    </p>
                                    {/* <p className="anotc__mp-result-item-title small">Atendente</p> */}
                                  </div>
                                  <div className="anotc__mp-result-item-critic med">
                                    {/* <img src="build/images/report/whatsapp_icon.png" width="15" alt="" /> */}
                                    {data_envio}
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })()}

                        <div
                          className="anotc__mp-result-btn--recent"
                          onClick={(event) =>
                            ShowModals(
                              event,
                              "modal__mensagens-favoritas-details",
                              selectedChat.telefone,
                              selectedChat.idatendimento,
                              selectedChat.cliente
                            )
                          }
                        >
                          Ver tudo
                        </div>
                      </div>
                    </div>
                    <div
                      className={`details-line ${
                        detailsOptions.shareArchives ? "open" : ""
                      }`}
                      onClick={(e) => {
                        if (!detailsOptions.shareArchives) {
                          buttonSearchFileCompart(e, selectedChat.telefone);
                        }
                        setDetailsOptions({
                          ...detailsOptions,
                          shareArchives: !detailsOptions.shareArchives,
                        });
                      }}
                    >
                      <div className="details-line__header">
                        <Typography.H4 weight={700} color={"blue-selected-4"}>
                          Arquivos compartilhados
                        </Typography.H4>
                        <ArrowDown />
                      </div>
                      <div
                        // className={
                        //   this.state.buttonFileComptd
                        //     ? "anotc__recent-content active"
                        //     : "anotc__recent-content"
                        // }
                        style={{
                          display: detailsOptions.shareArchives
                            ? "flex"
                            : "none",
                          flexDirection: "column",
                        }}
                      >
                        {(() => {
                          if (
                            DetailsFileSharedIn.detailsfileshared &&
                            DetailsFileSharedIn.detailsfileshared.length !== 0
                          ) {
                            var cliente = createJSON(selectedChat.cliente);
                            var nameC =
                              DetailsFileSharedIn.detailsfileshared[0]
                                .usuario_anotacao;
                            var formato =
                              DetailsFileSharedIn.detailsfileshared[0].formato;
                            var idmidia =
                              DetailsFileSharedIn.detailsfileshared[0].idmidia;
                            var data_envio =
                              DetailsFileSharedIn.detailsfileshared[0]
                                .data_envio;
                            var mensagem =
                              DetailsFileSharedIn.detailsfileshared[0].mensagem;
                            var tamanhourl = dbfileSize(
                              DetailsFileSharedIn.detailsfileshared[0].filesize
                            );
                            return (
                              <div>
                                <div className="anotc__mp-result-item-info--recent no-padding">
                                  <div className="anotc__mp-result-item-info--recent__header">
                                    <div className="arq-comp__t-sort">
                                      <span className="arq-comp__t-sort_ft">
                                        {formato}
                                      </span>
                                    </div>

                                    <div className="anotc__mp-result-item-info--recent__header__title">
                                      <p className="anotc__mp-result-item-name">
                                        {"Arquivo em " + formato}
                                      </p>
                                      <p className="anotc__mp-result-item-title">
                                        {tamanhourl}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="anotc__mp-result-item-info--recent__main">
                                  <div className="line">
                                    <p className="anotc__mp-result-item-info--recent__main__name">
                                      Data:
                                    </p>
                                    <p className="anotc__mp-result-item-info--recent__main__value">
                                      {data_envio}
                                    </p>
                                  </div>
                                  <div className="line">
                                    <p className="anotc__mp-result-item-info--recent__main__name">
                                      Canal:
                                      {(() => {
                                        getMediaIcon(idmidia);
                                      })()}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })()}

                        <div
                          className="anotc__mp-result-btn--recent"
                          onClick={(event) =>
                            ShowModals(
                              event,
                              "modal__arquivos-compartilhados-details",
                              selectedChat.telefone,
                              selectedChat.idatendimento,
                              selectedChat.cliente
                            )
                          }
                        >
                          Ver tudo
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </main>
            </div>
          </div>
        </div>
      </div>

      <TransferClientModal
        dashboardMonitor={true}
        setMonitorDash={setTransferInfo}
      />

      {/* Modal de adicionar anotação */}
      <AddAnotationModal selectedChat={selectedChat} />
      {/* <NewAnotationModal /> */}
    </>
  );
};

export default MonitoringDashboard;
